import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from '../../utility/axios';
import '../../styles/auth/Login.css';


const SetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { uniqueIdentifier } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEmail = async () => {
            try {
                const response = await axios.get(`/api/get-email/${uniqueIdentifier}/`);
                setEmail(response.data.email);
            } catch (error) {
                setErrorMessage('Failed to load user information');
            }
        };
        fetchEmail();
    }, [uniqueIdentifier]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        
        if (password !== confirmPassword) {
            setErrorMessage('Passwords do not match');
            return;
        }

        if (!uniqueIdentifier) {
            setErrorMessage('Invalid password reset link');
            return;
        }

        try {
            await axios.post(`/api/set-password/${uniqueIdentifier}/`, {
                password,
                unique_identifier: uniqueIdentifier
            });
            message.success('Password set successfully');
            navigate('/login');
        } catch (error) {
            if (error.response?.status === 404) {
                setErrorMessage('Invalid or expired password reset link');
                return;
            }
            setErrorMessage(error.response?.data?.error || 'An error occurred while setting password');
        }
    };

    const togglePasswordVisibility = (field) => {
        if (field === 'password') {
            setShowPassword(!showPassword);
        } else {
            setShowConfirmPassword(!showConfirmPassword);
        }
    };

    return (
        <div className="loginFormContainer">
            <h2 className="loginFormTitle">Set Your Password</h2>

            {errorMessage && (
                <div className="errorMessage">{errorMessage}</div>
            )}

            <form onSubmit={handleSubmit} className="loginForm">
                <div className="loginUsernameForm">
                    <input
                        type="email"
                        value={email}
                        readOnly
                        className="loginFormInput disabled"
                        placeholder="Email"
                    />
                </div>

                <div className="loginPasswordForm">
                    <div className="passwordInputContainer">
                        <input
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="loginFormInput"
                            placeholder="Password"
                        />
                        <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                            onClick={() => togglePasswordVisibility('password')}
                            className="passwordToggleIcon"
                        />
                    </div>
                </div>

                <div className="loginPasswordForm">
                    <div className="passwordInputContainer">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="loginFormInput"
                            placeholder="Confirm password"
                        />
                        <FontAwesomeIcon
                            icon={showConfirmPassword ? faEyeSlash : faEye}
                            onClick={() => togglePasswordVisibility('confirm')}
                            className="passwordToggleIcon"
                        />
                    </div>
                </div>

                <button type="submit" className="loginFormButton">
                    Set Password
                </button>
            </form>
            <div className="loginSeperator"></div>
            <div className="registerDescription">
                <p>Already have an account? <Link to="/login" className="register-link">Login</Link></p>
            </div>
        </div>
    );
};

export default SetPassword;